import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

const ButtonContainer1 = ({ className = "" }) => {
  const navigate = useNavigate();

  const onMyCaBClick = useCallback(() => {
    navigate("/41-history-5");
  }, [navigate]);

  const onXemcoxinheTextClick = useCallback(() => {
    navigate("/41-setting-wifi1");
  }, [navigate]);

  const onRectangleClick = useCallback(() => {
    navigate("/42-setting-wifi-done");
  }, [navigate]);

  return (
    <div
      className={`w-full !m-[0] absolute top-[0px] left-[0px] flex flex-row items-start justify-start max-w-full text-left text-3xs text-dark-text font-text-regular-lowercase ${className}`}
    >
      <div className="h-40 w-[360px] absolute !m-[0] bottom-[-23px] left-[calc(50%_-_180px)] rounded-t-xl rounded-b-none bg-light-orange" />
      <div className="flex-1 rounded-t-21xl rounded-b-none bg-light-pink flex flex-col items-start justify-start pt-9 px-10 pb-14 box-border gap-[29px] max-w-full">
        <div className="self-stretch h-40 relative rounded-xl bg-light-pink hidden" />
        <div className="w-[175px] relative leading-[120%] hidden items-center">
          <span className="w-full">
            <p className="m-0 text-lg">
              <span className="whitespace-pre-wrap">
                <span className="font-semibold">Máy mới cho Hùng</span>
              </span>
            </p>
            <p className="m-0">
              <span className="whitespace-pre-wrap">
                <span className="whitespace-pre-wrap">
                  <span className="whitespace-pre-wrap">&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0 text-light-text">
              <span className="whitespace-pre-wrap">
                <span className="whitespace-pre-wrap">
                  <span>Pin 18%</span>
                </span>
              </span>
            </p>
            <p className="m-0 text-dark-pink">
              <span className="whitespace-pre-wrap">
                <span className="whitespace-pre-wrap">
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0 text-sm">
              <span>
                <span className="whitespace-pre-wrap">
                  <span>Chưa nói câu từ lần cuối</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span className="font-semibold whitespace-pre-wrap">
                  &nbsp;
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span className="font-semibold whitespace-pre-wrap">
                  {" "}
                  Xem lịch sử nói chuyện
                </span>
              </span>
            </p>
          </span>
        </div>
        <img
          className="w-[116px] relative max-h-full object-cover hidden"
          alt=""
          src="/device-12-low-battery-1@2x.png"
        />
        <div
          className="relative leading-[120%] hidden cursor-pointer"
          onClick={onMyCaBClick}
        >
          <p className="m-0 text-lg">
            <span className="whitespace-pre-wrap">
              <span className="font-semibold">Máy của bé My</span>
            </span>
          </p>
          <p className="m-0">
            <span className="whitespace-pre-wrap">
              <span className="whitespace-pre-wrap">
                <span className="whitespace-pre-wrap">&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0 text-light-text">
            <span className="whitespace-pre-wrap">
              <span className="whitespace-pre-wrap">
                <span>Pin 18%</span>
              </span>
            </span>
          </p>
          <p className="m-0 text-dark-pink">
            <span className="whitespace-pre-wrap">
              <span className="whitespace-pre-wrap">
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0 text-sm">
            <span>
              <span className="whitespace-pre-wrap">
                <span>2000 câu từ lần cuối</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span className="font-semibold whitespace-pre-wrap">&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span className="font-semibold whitespace-pre-wrap">
                {" "}
                Xem lịch sử nói chuyện
              </span>
            </span>
          </p>
        </div>
        <img
          className="w-[9px] h-[9px] relative overflow-hidden shrink-0 hidden"
          alt=""
          src="/calendar-month.svg"
        />
        <img
          className="w-[9px] h-[9px] relative overflow-hidden shrink-0 hidden"
          alt=""
          src="/calendar-month.svg"
        />
        <img
          className="w-[116px] relative max-h-full object-cover hidden"
          alt=""
          src="/device-22-no-connect-1@2x.png"
        />
        <div className="self-stretch h-[60px] relative rounded-81xl bg-light-primary-key-background border-dark-text border-solid border-[2px] box-border hidden" />
        <div className="relative text-base hidden min-w-[86px]">vietnam@1</div>
        <div className="w-[440px] h-[346px] relative rounded-t-21xl rounded-b-none bg-light-pink hidden max-w-full" />
        <h2
          className="m-0 self-stretch relative text-21xl leading-[160%] font-semibold font-[inherit] text-center cursor-pointer z-[1]"
          onClick={onXemcoxinheTextClick}
        >
          xemcoxinhe
        </h2>
        <div className="self-stretch h-[161px] flex flex-col items-start justify-start gap-[41px] max-w-full mq360:gap-5">
          <div className="self-stretch flex-1 rounded-81xl bg-light-primary-key-background border-dark-text border-solid border-[2px] box-border flex flex-row items-start justify-start py-[17px] px-[29px] max-w-full z-[1]">
            <div className="h-[60px] w-[360px] relative rounded-81xl bg-light-primary-key-background border-dark-text border-solid border-[2px] box-border hidden max-w-full" />
            <input
              className="w-[105px] [border:none] [outline:none] font-text-regular-lowercase text-base bg-[transparent] relative text-dark-text text-left inline-block p-0 z-[2]"
              placeholder="Mật khẩu wifi"
              type="text"
            />
          </div>
          <button className="cursor-pointer [border:none] p-0 bg-[transparent] self-stretch h-[60px] relative z-[1]">
            <div
              className="absolute top-[0px] left-[0px] rounded-81xl [background:linear-gradient(90deg,_#ff92d7,_#ffbc92)] w-full h-full cursor-pointer"
              onClick={onRectangleClick}
            />
            <div className="absolute top-[20px] left-[120px] text-base font-medium font-text-regular-lowercase text-light-primary-key-background text-center inline-block min-w-[120px] z-[1]">
              Đăng nhập wifi
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

ButtonContainer1.propTypes = {
  className: PropTypes.string,
};

export default ButtonContainer1;
